export default "__VITE_ASSET__BKf1UJnf__"